/**
 * Feature 2: Sticky Filter Bar — scroll shadow trigger
 * Save as: assets/behuli-sticky-filter.js
 * Load in theme.liquid before </body>:
 *   <script src="{{ 'behuli-sticky-filter.js' | asset_url }}" defer></script>
 */
(function () {
  var threshold = 60;
  window.addEventListener('scroll', function () {
    document.body.classList.toggle('behuli-filter-scrolled', window.scrollY > threshold);
  }, { passive: true });
})();
